export const TYPE_PLAYER_LEAVE = 'player_leave'

class PlayerLeave {
    
    constructor(data) {
        this.data = data;
    }
    
    handle(game) {
        const data = this.data;
        //const player = game.getPlayerById(data.id).delete();
        const players = game.getPlayers();
        players.getById(data.id).destroy();
    }
    
}

export default PlayerLeave
